import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_SEARCH_FIELDS } from "../http-params.util";

/**
 * GlcodesApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/glcodesApi/glcodesApi.service.js.
 *
 * Legacy uses `/v1/api/glcode` and replaces `/v1/` → `/v2/` for `list()`. We
 * hardcode the v2 URL.
 */
const GLCODES_FILES_METADATA_BASE_V2 = "/v2/api/glcode/files/metadata";

@Injectable({ providedIn: "root" })
export class GlcodesApiService {
  private readonly http = inject(HttpClient);

  list(props?: Record<string, unknown>): Promise<AjsResponse<unknown>> {
    return wrapAjs(
      this.http.get<unknown>(GLCODES_FILES_METADATA_BASE_V2, {
        params: buildParams(props, PAGINATION_SEARCH_FIELDS),
      }),
    );
  }
}
